export const CREATE_COMMUNITY_REQUEST = "CREATE_COMMUNITY_REQUEST";
export const CREATE_COMMUNITY_SUCCESS = "CREATE_COMMUNITY_SUCCESS";
export const CREATE_COMMUNITY_FAILURE = "CREATE_COMMUNITY_FAILURE";

export const FETCH_COMMUNITY_REQUEST = "FETCH_COMMUNITY_REQUEST";
export const FETCH_COMMUNITY_SUCCESS = "FETCH_COMMUNITY_SUCCESS";
export const FETCH_COMMUNITY_FAILURE = "FETCH_COMMUNITY_FAILURE";

export const JOIN_COMMUNITY_REQUEST = "JOIN_COMMUNITY_REQUEST";
export const JOIN_COMMUNITY_SUCCESS = "JOIN_COMMUNITY_SUCCESS";
export const JOIN_COMMUNITY_FAILURE = "JOIN_COMMUNITY_FAILURE";

export const LEAVE_COMMUNITY_REQUEST = "LEAVE_COMMUNITY_REQUEST";
export const LEAVE_COMMUNITY_SUCCESS = "LEAVE_COMMUNITY_SUCCESS";
export const LEAVE_COMMUNITY_FAILURE = "LEAVE_COMMUNITY_FAILURE";

export const FETCH_ALL_COMMUNITY_REQUEST = "FETCH_ALL_COMMUNITY_REQUEST";
export const FETCH_ALL_COMMUNITY_SUCCESS = "FETCH_ALL_COMMUNITY_SUCCESS";
export const FETCH_ALL_COMMUNITY_FAILURE = "FETCH_ALL_COMMUNITY_FAILURE";

export const FETCH_COMMUNITY_MEMBERS_REQUEST =
  "FETCH_COMMUNITY_MEMBERS_REQUEST";
export const FETCH_COMMUNITY_MEMBERS_SUCCESS =
  "FETCH_COMMUNITY_MEMBERS_SUCCESS";
export const FETCH_COMMUNITY_MEMBERS_FAILURE =
  "FETCH_COMMUNITY_MEMBERS_FAILURE";

export const COMMUNITY_APPROVAL_REQUEST = "COMMUNITY_APPROVAL_REQUEST";
export const COMMUNITY_APPROVAL_SUCCESS = "COMMUNITY_APPROVAL_SUCCESS";
export const COMMUNITY_APPROVAL_FAILURE = "COMMUNITY_APPROVAL_FAILURE";

export const CLOSE_COMMUNITY_MODAL_REQUEST = "CLOSE_COMMUNITY_MODAL_REQUEST";
